module.exports = __webpack_public_path__ + "img/natural.2aeb2a5.jpg";